var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1807 9.57373H16.3994V6.44873C16.3994 3.00186 13.5963 0.19873 10.1494 0.19873C6.70254 0.19873 3.89941 3.00186 3.89941 6.44873V9.57373H3.11816C1.8265 9.57373 0.774414 10.6248 0.774414 11.9175V22.855C0.774414 24.1477 1.8265 25.1987 3.11816 25.1987H17.1807C18.4723 25.1987 19.5244 24.1477 19.5244 22.855V11.9175C19.5244 10.6248 18.4723 9.57373 17.1807 9.57373ZM5.98275 6.44873C5.98275 4.15081 7.8515 2.28206 10.1494 2.28206C12.4473 2.28206 14.3161 4.15081 14.3161 6.44873V9.57373H5.98275V6.44873ZM11.1911 17.6175V19.9904C11.1911 20.5654 10.7255 21.0321 10.1494 21.0321C9.57337 21.0321 9.10775 20.5654 9.10775 19.9904V17.6175C8.48796 17.256 8.06608 16.5914 8.06608 15.8237C8.06608 14.6748 9.00045 13.7404 10.1494 13.7404C11.2984 13.7404 12.2327 14.6748 12.2327 15.8237C12.2327 16.5914 11.8109 17.256 11.1911 17.6175Z",
    fill: "#808897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.3c27e79bb270c260b83724224e6228e4.svg";
export { ForwardRef as ReactComponent };